module.exports = __webpack_public_path__ + "img/check-circle.e0cdee2b.svg";